import { type Theme, setTheme, useTheme } from '@/lib/theme';
import { cn } from '@/lib/cn';

const ORDER: Theme[] = ['light', 'dark', 'system'];
const ICONS: Record<Theme, string> = {
  light: '☀',
  dark: '☾',
  system: '⌒',
};
const LABELS: Record<Theme, string> = {
  light: 'Light',
  dark: 'Dark',
  system: 'System',
};

/**
 * Cycle through Light → Dark → System on click. Three-state because
 * the user might want to override their OS preference one way or the
 * other; "System" is the friendly default that respects whatever the
 * OS is set to.
 */
export function ThemeToggle() {
  const theme = useTheme();
  const next = ORDER[(ORDER.indexOf(theme) + 1) % ORDER.length];

  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      title={`Theme: ${LABELS[theme]} (click for ${LABELS[next]})`}
      aria-label={`Switch theme (currently ${LABELS[theme]})`}
      className={cn(
        'flex items-center gap-1 rounded-md border border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900 px-2 py-1 text-sm',
        'hover:bg-stone-100 dark:hover:bg-stone-800',
        'dark:border-stone-700 dark:bg-stone-900 dark:hover:bg-stone-800',
      )}
    >
      <span aria-hidden className="inline-block w-4 text-center">
        {ICONS[theme]}
      </span>
      <span className="text-xs text-stone-500 dark:text-stone-400">
        {LABELS[theme]}
      </span>
    </button>
  );
}
